import React from 'react';
import { SEARCH_CLEAR_ACTION_CLASS_PREFIX, searchInputClearIcon } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
import { useSearchClearActionClassName } from './hooks';
import { ClearIconRoot, SearchInputClearIcon } from './style';
import { searchClearActionTheme } from './theme';
export var SearchClearAction = function SearchClearAction(_ref) {
  var className = _ref.className,
      disableClearAction = _ref.disableClearAction,
      handleClearQuery = _ref.handleClearQuery,
      disabled = _ref.disabled,
      searchQuery = _ref.searchQuery;
  var theme = useComponentTheme(SEARCH_CLEAR_ACTION_CLASS_PREFIX, searchClearActionTheme);
  var classOverride = useSearchClearActionClassName(SEARCH_CLEAR_ACTION_CLASS_PREFIX, className, disabled);
  return disableClearAction ? null : React.createElement(ClearIconRoot, {
    className: classOverride.AfterIconContainer,
    onClick: handleClearQuery,
    theme: theme
  }, React.createElement(SearchInputClearIcon, {
    className: classOverride.AfterIcon,
    "data-testid": searchInputClearIcon,
    disabled: disabled,
    searchQuery: searchQuery,
    theme: theme
  }));
};